import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { errorHandler } from 'src/app/shared/helpers/error-handler';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserService } from 'src/app/shared/services/user.service';
import { environment } from 'src/environments/environment';
import { RecoverPasswordComponent } from '../recover-password/recover-password.component';
import { LocationStrategy, PlatformLocation } from '@angular/common';
import { CompanyService } from 'src/app/shared/services/company.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { PntClaims } from 'src/app/shared/const/pnt-claims';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
import { MsalService } from '@azure/msal-angular';
import { take } from 'rxjs/operators';

const jwt = new JwtHelperService();

declare var Keycloak: any;

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form: FormGroup = this.fb.group({
    identifier: [null, Validators.required],
    // email: ['rodrigo.moura@planetun.com.br', Validators.required],
    password: [null],
    //password: ['Teste@123', Validators.required],
    cpf: [null]
  });

  formRecovery: FormGroup = this.fb.group({
    identifier: [null, Validators.required]
  });

  formToken: FormGroup = this.fb.group({
    token: [null, Validators.required],
    identifier: [null, Validators.required],
    newPassword: [null, Validators.required],
    confirmPassword: [null, Validators.required]
  });

  login: boolean = true;
  term: boolean = false
  select: boolean = false;
  change: boolean = false;
  expire: boolean = false;
  insurance: boolean = false;
  forgot: boolean = false;
  isProviderValue: boolean = false;
  isBrokerValue: boolean = false;
  listCompanyOne: any[] = [];
  listCompanyTwo: any[] = [];
  accessToken: any;
  companyId: any;
  personId: any;
  termId: any;
  termText: any;
  providerStr: any;
  insuranceStr: any = [];
  companyValue: any;
  tokenValue: any;
  document: any;
  emails: any[] = [];
  error: boolean = false;
  errorMsg: any;
  providerId: any;
  isStepCompany: boolean = false;
  isStepInsurance: boolean = false;
  
  // Propriedades para Azure AD
  ids: any[] = [];
  userGroups: any[] = [];
  userName: string = '';
  email: string = '';
  azureAdToken: string = '';
  isEmail = false;
  needsCpf = false;
  ssoConfig = null;


  constructor(
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private userService: UserService,
    private platformLocation: PlatformLocation,
    private location: LocationStrategy,
    private companyService: CompanyService,
    private msalService: MsalService
  ) {
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
      this.providerId = undefined;
      this.isStepCompany = false;
      this.isStepInsurance = false;
      this.insurance = false;
      this.firstStep();
    });
  }

  private isEmailLike(value: string): boolean {
    return /[a-zA-Z@]/.test(value);
  }

  private maskCpf(value: string): string {
    return value
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  private maskCnpj(value: string): string {
    return value
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }


  getDomains(item: any): string[] {
    return item.dominio
      .split(',')
      .map(x => x.trim().toLowerCase());
  }

  domainInConfig(domain: string): boolean {
    domain = domain.toLowerCase();
    return this.ssoConfig.data.some(item => this.getDomains(item).includes(domain));
  }

  onIdentifierInput() {
    let value = this.form.get('identifier')?.value || '';

    // 1️⃣ E-mail
    if (this.isEmailLike(value)) {
      this.isEmail = true;
      return; // não mascara
    }

    // 2️⃣ Documento (CPF ou CNPJ)
    this.isEmail = false;

    let numbers = value.replace(/\D/g, '');

    // Limite máximo CNPJ (14)
    numbers = numbers.substring(0, 14);

    // CPF
    if (numbers.length <= 11) {
      value = this.maskCpf(numbers);
    }
    // CNPJ
    else {
      value = this.maskCnpj(numbers);
    }

    this.form.get('identifier')?.setValue(value, { emitEvent: false });
  }


  onIdentifierBlur() {
    const value = (this.form.get('identifier')?.value || '').trim();

    // Detecta se é e-mail
    this.isEmail = this.isEmailLike(value);

    // se não é email (é CPF), não precisa de verificação extra
    if (!this.isEmail) {
      this.needsCpf = false;
      return;
    }

    // verifica o domínio
    const [_, domain] = value.split('@');
    console.log("Dominio detectado:", domain);
    sessionStorage.setItem('domainIdp', domain);
    if (!this.domainInConfig(domain)) {
      console.log("Domínio não integrado:", domain);
      // se for e-mail de outro domínio, use o fluxo padrão (não integrado)
      this.needsCpf = false;
      return;
    }
    console.log("Domínio integrado:", domain);

    // chama a API para ver se o usuário existe
    this.authService.checkUserByEmailHub(value).subscribe({
      next: (resp) => {
        if (resp.document) {
          // usuário já existe → seguir direto para o login Keycloak
          sessionStorage.setItem('tempCpf', resp.document);
          this.needsCpf = false;
          this.redirectToKeycloakLogin();
        } else {
          // usuário não existe → pedir o CPF extra
          this.needsCpf = true;
          // tornar o campo CPF obrigatório
          this.form.get('cpf')?.setValidators([Validators.required]);
          this.form.get('cpf')?.updateValueAndValidity();
        }
      },
      error: (err) => {
        console.error('Erro ao verificar e-mail', err);
        this.toastr.error('Falha ao validar e-mail');
      }
    });
  }

  onRecoveryIdentifierInput() {
    let value = this.formRecovery.get('identifier')?.value || '';

    // Remove tudo que não for número
    let numbers = value.replace(/\D/g, '');

    // Limite máximo CNPJ
    numbers = numbers.substring(0, 14);

    // Aplica máscara
    if (numbers.length <= 11) {
      value = this.maskCpf(numbers);
    } else {
      value = this.maskCnpj(numbers);
    }

    this.formRecovery
      .get('identifier')
      ?.setValue(value, { emitEvent: false });
  }

  onTokenIdentifierInput() {
    let value = this.formToken.get('identifier')?.value || '';

    let numbers = value.replace(/\D/g, '').substring(0, 14);

    if (numbers.length <= 11) {
      value = this.maskCpf(numbers);
    } else {
      value = this.maskCnpj(numbers);
    }

    this.formToken
      .get('identifier')
      ?.setValue(value, { emitEvent: false });
  }

  private redirectToKeycloakLogin() {
    const domain = sessionStorage.getItem('domainIdp') || '';
    console.log("Redirecionando para Keycloak com domínio:", domain);
    const idpName =
    this.ssoConfig.data.find(item => {
      const dominios = item.dominio
        .split(',')
        .map(x => x.trim().toLowerCase());
      return dominios.includes(domain.toLowerCase());
    })?.identityProviderName || 'saml';
    console.log("Usando IdP:", idpName);
    const params = new URLSearchParams({
      client_id: 'hub',
      redirect_uri: `${window.location.origin}/auth/login`,
      response_type: 'code',
      scope: 'openid profile email',
      kc_idp_hint: idpName
    });
    window.location.href =
      `${environment.keyCloakAdUrl}?${params.toString()}`;
  }


  async ngOnInit() {
    console.log("LoginComponent initialized");
    this.spinner.show();
    this.ssoConfig = await this.authService.getSsoConfiguration().pipe(take(1)).toPromise();
    console.log("SSO Configuration:", this.ssoConfig);
    const params = await this.route.queryParamMap.pipe(take(1)).toPromise();
    console.log("Query Params:", params.keys);
    const code = params.get('code');

    console.log("Authorization Code:", code);

    if (code) {
      const resp = await this.authService.exchangeCodeForToken(code).pipe(take(1)).toPromise();
      const accessToken = resp['access_token'];
      const tempCpf = sessionStorage.getItem('tempCpf');

      const idToken = resp['id_token']; // necessário para logout SSO
      console.log("ID Token recebido:", idToken);
      sessionStorage.setItem("kc_id_token", idToken);

      console.log ("Id Token armazenado para logout SSO:", sessionStorage.getItem("kc_id_token"));

      console.log("Access Token:", accessToken);
      console.log("Temp CPF:", tempCpf);
      sessionStorage.removeItem('tempCpf');

      const domain = sessionStorage.getItem('domainIdp') || '';
      console.log("Domain for SSO login:", domain);
      const dataItem = this.ssoConfig.data.find(item => {
        const dominios = item.dominio
          .split(',')
          .map(d => d.trim().toLowerCase());
        return dominios.includes(domain.toLowerCase());
      });
      console.log("SSO Config Data Item:", dataItem);
      const companyIds = dataItem ? dataItem.fkCompanies.map(c => c.hubCompanyID) : [];
      console.log("Company IDs for SSO login:", companyIds);

      const response = await this.authService.loginWithKeycloakTokens(accessToken, tempCpf, companyIds).pipe(take(1)).toPromise();

      console.log("Resposta da API após login com Keycloak:", response);
      this.spinner.hide();
      this.firstStep(response["user"]["loginIdentityHub"]);

      // sai completamente do método ngOnInit
      return;
    }
    else {
      this.spinner.hide();
    }
    
    

    this.resetFlags();

    const isAd = localStorage.getItem('ad');

    // Verifica se há parâmetros de retorno do Azure AD na URL
    if (this.router.url.includes('state') || this.router.url.includes('code')) {
      await this.handleAzureADCallback();
      return;
    }

    // Verifica se há parâmetro isAd na URL
    const urlParams = new URLSearchParams(window.location.search);
    const isAdParam = urlParams.get('isAd');
    
    if (isAdParam === 'true') {
      localStorage.setItem('ad', 'true');
      this.keyInit();
      return;
    }

    if (isAd === 'true' && localStorage.getItem('data') !== null) {
    
  //   let teste = JSON.stringify({
  //     "success": true,
  //     "data": {
  //         "accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2OTE5IiwiZW1haWwiOiJqb25hcy5zaWx2YUBwbGFuZXR1bi5jb20uYnIiLCJqdGkiOiIwN2RkNGViYi0yMmY3LTQyMWYtYjhjOC05OGU5OTk4MTZjMzEiLCJuYmYiOjE3NTU4MDc1NzcsImlhdCI6MTc1NTgwNzU3NywiVXNlck5hbWUiOiIiLCJPZmZpY2UiOiItIiwiQXJlYSI6Ii0iLCJQZXJzb24iOiItIiwibG9naW4iOiIwMzY0ODIzMTE5NyIsImV4cCI6MTc1NTgxNDc3NywiaXNzIjoiTWV1U2lzdGVtYSIsImF1ZCI6Imh0dHBzOi8vbG9jYWxob3N0In0.KFXFo1LvjPsZYE_AIUxPig8XiD0_eFkT3yFljxJIk00",
  //         "expiresIn": 7200,
  //         "expiredPassword": false,
  //         "userToken": {
  //             "id": "6919",
  //             "email": "JCAZEVED@bbmapfre.com.br",
  //             "claims": [
  //                 {
  //                     "value": "6",
  //                     "type": "Profile"
  //                 },
  //                 {
  //                     "value": "893a4f2f-020a-41dc-ae71-543f720bc265",
  //                     "type": "CompanyPersonId"
  //                 },
  //                 {
  //                     "value": "1a3bc78c-d214-4e52-a140-9cae19ee2ab9",
  //                     "type": "InsuranceId"
  //                 },
  //                 {
  //                     "value": "6912",
  //                     "type": "sub"
  //                 },
  //                 {
  //                     "value": "JCAZEVED@bbmapfre.com.br",
  //                     "type": "email"
  //                 },
  //                 {
  //                     "value": "f4350de9-f9b3-41f6-8ef6-f082262111d3",
  //                     "type": "jti"
  //                 },
  //                 {
  //                     "value": "1741284495",
  //                     "type": "nbf"
  //                 },
  //                 {
  //                     "value": "1741284495",
  //                     "type": "iat"
  //                 },
  //                 {
  //                     "value": "JOAO CARLOS MELO AZEVEDO",
  //                     "type": "UserName"
  //                 },
  //                 {
  //                     "value": "-",
  //                     "type": "Office"
  //                 },
  //                 {
  //                     "value": "-",
  //                     "type": "Area"
  //                 },
  //                 {
  //                     "value": "0447a8a9-c4e3-4876-8e4b-ffb04297eb1c",
  //                     "type": "Person"
  //                 }
  //             ]
  //         },
  //         "profiles": [
  //           "6025afd1-41c8-4c69-8316-a9b46402307e",
  //           "ce232b9e-9215-40c5-9e05-066bb81a767d",
  //           "4e0cbc29-c954-4d64-9a01-083f6716a148",
  //           "7d055208-80d2-4f59-8a50-0315a173e2c0",
  //           "fe1a345c-f73f-4d1b-be21-7d0a1b04ad09",
  //           "de346ff7-2021-4550-8de0-e770b8e4b14a",
  //           "6f2d42d9-6113-4866-bf1a-4eb6eef7cb6a",
  //           "283377b6-4e0a-4f0d-92b6-f8547a744017",
  //           "462c301b-e309-412e-9b16-73099f115c12",
  //           "c40b48f5-2b5f-477f-8530-976db6cdd33e",
  //           "ccf53210-7ea0-4bc1-87ca-dfab90b06c41",
  //           "0557d79d-7535-4dea-aa38-b45a0e884389",
  //           "c34438a5-6a87-4d0f-bd34-272d4566dfdd",
  //           "745c6f79-3149-4c32-92c1-8a7a0fa02202",
  //           "c10c3be4-8d82-4fda-9aca-9bd23da83500",
  //           "556a070e-87e9-412e-98eb-f137b718fd82",
  //           "f69d2909-e26d-4d28-a1de-c14434a24a0e",
  //           "76bc3a1a-9edf-4f59-8588-d81d8c607dfa",
  //           "f0a8318b-06c2-47cb-b91f-a27751d957b1",
  //           "b274ceac-6e9e-48d1-8ff9-9a633357f43d",
  //           "e31e9e50-dc1b-4b15-bdf3-c5cee20fcc5e",
  //           "0c6d695e-8b84-4ca9-b2ae-b8e9312185b1",
  //           "a58e7ff8-a91a-4798-9a3a-7657962b76df",
  //           "3fdb2326-632e-4fc5-ad1b-066471fd4643",
  //           "59cc1113-42fd-4bfb-a395-2dd7e76a35f6",
  //           "90774ea9-a2f8-4998-9cae-f427a8f4f5b3",
  //           "14e5dbe1-f435-4bae-918b-17ff4f73cbd7",
  //           "64c079de-d5c0-4405-9632-45969802138c",
  //           "f4145d03-a7b6-4345-9246-8aef7867cef4",
  //           "3f58db44-ffa4-4b92-8536-3d93b8cf964d",
  //           "9310d039-85b1-4b0e-a981-3eb716132b98",
  //           "92f0f990-27e9-4aff-a304-a8796f48fc62",
  //           "8e1894f4-6322-40b9-b554-0f1b77c9bdd8",
  //           "3148ed88-cfbf-4fb3-b8cb-ff87c7249a3e",
  //           "774b9fb6-d88f-4ea4-b972-ff15cf575673",
  //           "4d40ead5-59c5-42f9-a61f-0686cfbc2dda",
  //           "5792aeaf-e41e-4bd8-9d04-f786054d585b",
  //           "f33fdaa0-7bfc-42fd-acdd-1b5afbd1872a",
  //           "a0462edc-13e9-4dec-a782-f800185d137f",
  //           "3ed91df4-029a-42b1-aa3c-1bb3f796ca39",
  //           "e977e366-c243-484c-b0c9-15ef96820e45",
  //           "cd96dc03-1634-4f17-a49b-8be4de4eb0d1"
  //         ]
  //     }
  // });
  // localStorage.setItem('data', teste);

  const objAd = JSON.parse(localStorage.getItem('data'));
  localStorage.removeItem('ad');
  localStorage.removeItem('data');
  localStorage.setItem('cp_tkn_x', objAd.data.accessToken);
  let _objUser = await this.authService.getDecodedToken();


  Object.assign(_objUser, this.getClaimsByProfile(Number(objAd.data.userToken.claims.find(x => x.type === 'Profile').value)));

  await this.authService.createToken(_objUser).then(async token => {
    localStorage.setItem('cp_tkn_x', token);

   
    const result: any = await this.authService.authenticate(null, token);
    const values = result.body.data[0];

    this.tokenValue = decodeURI(token);
    this.fToken.token.setValue(this.tokenValue.replaceAll(" ", "+"));
    this.change = false;
    this.expire = false;

    this.listCompanyOne = values.companyPersons;
    window.localStorage.setItem('listInsurance', JSON.stringify(this.listCompanyOne));


    if (Object.keys(values.companyPersons).length === 0) {
      this.toastr.error(errorHandler("O usuário não está associado a nenhuma empresa"), 'Falha na autenticação!');
    } else {
      if (this.listCompanyOne.length == 1) {
        this.selectInsurance(this.listCompanyOne[0])
        this.select = false;
        return;
      }
      this.login = false;
      this.select = true;
      this.isStepCompany = true;
      this.isStepInsurance = false;
    }

  }).catch(error => {
    console.error("Erro ao obter token:", error);
  });
}else{

    const hasJwt = !!localStorage.getItem('cp_tkn_x');

    combineLatest([this.route.params, this.route.queryParams])
      .pipe(
        map(([p, q]) => ({
          step: Number(p['step'] || 0),
          tokenParam: (p['token'] ?? q['token'] ?? null) as string | null,
        })),
        distinctUntilChanged((a, b) =>
          a.step === b.step && a.tokenParam === b.tokenParam
        )
      )
      .subscribe(({ step, tokenParam }) => {

        this.login = false;
        this.select = false;
        this.change = false;
        this.expire = false;
        this.isStepCompany = false;
        this.isStepInsurance = false;

        const isCompanySwitch = step === 1 || step === 2;

        if (isCompanySwitch) {

          if (step === 2 && this.insuranceName && this.authService.token) {
            localStorage.removeItem('provider');
            this.selectInsurance(JSON.parse(this.insuranceName));
            this.isStepInsurance = true;
            return;
          }

          if (this.authService.token && this.listInsurance) {
            localStorage.removeItem('provider');
            this.listCompanyOne = JSON.parse(this.listInsurance);
          }
          this.select = true;
          this.isStepCompany = true;
          return;
        }

        if (tokenParam) {
          this.tokenValue = decodeURI(tokenParam);
          this.fToken.token.setValue(this.tokenValue.replaceAll(' ', '+'));
          this.change = true;
          this.expire = true;
          return;
        }

        this.login = !hasJwt;

        if (!this.login && !this.select && !this.change && !this.isStepCompany && !this.isStepInsurance) {
          this.login = true;
        }
      });
  }}

  resetFlags(): void {
    this.login = true;
    this.select = false;
    this.change = false;
    this.expire = false;
    this.isStepCompany = false;
    this.isStepInsurance = false;
  }

  getClaimsByProfile(profile: number): object {
    return PntClaims.filter(x => x.cod == profile)[0].claims;
  }

  setInsurance(insuranceId: string, idPerson: string) {
    let company = {};
    if (insuranceId == "1a3bc78c-d214-4e52-a140-9cae19ee2ab9") {
      company = {
        id: "f1dfdeac-01a3-4b33-a53e-08db5e145568",
        companyId: "f00c37cc-accf-48c7-8c21-50b63f32d1c1",
        personId: idPerson,
        company: {
          id: "f00c37cc-accf-48c7-8c21-50b63f32d1c1",
          companyName: "MAPFRE SEGUROS GERAIS S.A.",
          fantasyName: "MAPFRE - MATRIZ",
          cnpj: "61074175000138",
          isClient: true,
          isBranch: false,
          isProvider: false,
          isServiceStation: false,
          isBroker: false,
          companyId: "f00c37cc-accf-48c7-8c21-50b63f32d1c1"
        }
      }
    }
    return company;
  }

  async handleAzureADCallback() {
    return;
    try {
      this.spinner.show();
      console.log('🔄 Processando retorno do Azure AD...');
      console.log('URL atual:', window.location.href);
      
      
      // Verifica se há parâmetros de redirect na URL
      const urlParams = new URLSearchParams(window.location.search);
      const hasCode = urlParams.has('code');
      const hasState = urlParams.has('state');
      const hasError = urlParams.has('error');
      
      // Se não há parâmetros de redirect, pode não ser um callback válido
      if (!hasCode && !hasState && !hasError) {
        console.warn('⚠️ Não há parâmetros de redirect na URL');
        // Limpa a URL e tenta obter a conta diretamente
        window.history.replaceState({}, document.title, window.location.pathname);
        const account = this.msalService.getAccount();
        if (account) {
          await this.processAzureADLogin({ account });
          return;
        } else {
          this.toastr.warning('Sessão não encontrada. Por favor, faça login novamente.', 'Atenção!');
          this.login = true;
          return;
        }
      }
      
      // Se há erro na URL, trata o erro
      if (hasError) {
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');
        console.error('❌ Erro no redirect:', error, errorDescription);
        this.toastr.error(errorDescription || 'Erro na autenticação Azure AD', 'Falha na autenticação!');
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
      }
      
      // Processa o retorno do Azure AD apenas se houver parâmetros válidos
      try {
        const result = await this.msalService.handleRedirectCallback(null);
        console.log('✅ Resultado do callback:', result);
      } catch (handleError) {
        console.warn('⚠️ Erro ao processar handleRedirectCallback, tentando obter conta diretamente:', handleError);
        // Continua mesmo se handleRedirectCallback falhar, tenta obter a conta
      }
      
      // Obtém a conta ativa após o callback
      const account = this.msalService.getAccount();
      console.log('👤 Conta obtida:', account);
      
      // Limpa os parâmetros da URL após processar
      if (hasCode || hasState) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      
      if (account) {
        await this.processAzureADLogin({ account });
      } else {
        console.error('❌ Nenhuma conta encontrada após callback');
        this.toastr.error('Falha na autenticação Azure AD - Nenhuma conta encontrada', 'Erro!');
        this.login = true;
      }
    } catch (error) {
      console.error('❌ Erro ao processar retorno do Azure AD:', error);
      const errorMessage = error?.error?.message || error?.message || 'Erro desconhecido ao processar retorno do Azure AD';
      this.toastr.error(errorMessage, 'Falha na autenticação!');
      this.login = true;
    } finally {
      this.spinner.hide();
    }
  }

  async keyInit() {
    try {
      this.spinner.show();
      console.log('🚀 Iniciando login Azure AD...');
      
      // Verifica se já existe uma conta ativa
      const accounts = this.msalService.getAccount();
      console.log('👤 Contas existentes:', accounts);
      
      if (accounts) {
        console.log('✅ Conta encontrada, tentando login silencioso...');
        // Se já existe uma conta, tenta fazer login silencioso
        const silentRequest = {
          scopes: environment.azureAd.scopes,
          account: accounts
        };
        
        try {
          const silentResult = await this.msalService.acquireTokenSilent(silentRequest);
          console.log('✅ Login silencioso bem-sucedido:', silentResult);
          await this.processAzureADLogin(silentResult);
        } catch (error) {
          console.log('⚠️ Login silencioso falhou, fazendo login interativo...', error);
          // Se falhar o login silencioso, faz login interativo
          await this.performInteractiveLogin();
        }
      } else {
        console.log('❌ Nenhuma conta encontrada, fazendo login interativo...');
        // Se não há conta, faz login interativo
        await this.performInteractiveLogin();
      }
    } catch (error) {
      console.error('❌ Erro no login Azure AD:', error);
      this.toastr.error('Erro ao fazer login via Azure AD', 'Falha na autenticação!');
    } finally {
      this.spinner.hide();
    }
  }

  private async performInteractiveLogin() {
    const loginRequest = {
      scopes: environment.azureAd.scopes,
      prompt: 'select_account'
    };

    try {
      console.log('🔄 Iniciando login interativo...');
      console.log('Configuração do login:', loginRequest);
      console.log('Redirect URI:', environment.azureAd.redirectUri);
      
      // Usa loginRedirect em vez de loginPopup para melhor compatibilidade
      await this.msalService.loginRedirect(loginRequest);
      console.log('✅ Redirecionamento iniciado para Azure AD');
    } catch (error) {
      console.error('❌ Erro no login interativo:', error);
      this.toastr.error('Erro ao fazer login via Azure AD', 'Falha na autenticação!');
    }
  }

  setUserInfo() {
    this.ids = [];
    const account = this.msalService.getAccount();
    console.log('account', account);
    if (account) {
      // Obtém grupos do usuário usando Graph API
      this.getUserGroups().then((data: any) => {
        this.userGroups = data.value; // Contém os grupos
        console.log('Grupos:', this.userGroups);
        this.userGroups.forEach((group: any) => {
          this.ids.push(group.id);
        });
        const _profiles = this.getProfiles(this.ids);
        
        // As informações básicas do usuário estão disponíveis aqui
        this.userName = account.name || 'Usuário';
        this.email = account.userName || ''; // Normalmente contém o e-mail
        
        const body = new Object({
          userName: this.getUserFromEmail(account.userName || ''),
          document: "",
          email: account.userName || '',
          fullName: account.name || '',
          profiles: _profiles,
          azureAdToken: this.azureAdToken // Token do Azure AD
        });
        console.log('body2', body);
        
        this.sendRequestToADV(body);
      }).catch(err => {
        console.error('Erro ao obter grupos:', err);
        // Em caso de erro, continua sem grupos
        this.userGroups = [];
        this.ids = [];
        const _profiles = this.getProfiles(this.ids);
        
        this.userName = account.name || 'Usuário';
        this.email = account.userName || '';
        
        const body = new Object({
          userName: this.getUserFromEmail(account.userName || ''),
          document: "",
          email: account.userName || '',
          fullName: account.name || '',
          profiles: _profiles,
          azureAdToken: this.azureAdToken // Token do Azure AD
        });
        
        console.log('body2 (sem grupos):', body);
        this.sendRequestToADV(body);
      });
    }
  }

  getUserGroups() {
    const account = this.msalService.getAccount();
    console.log('account', account);
    
    if (!account) {
      return Promise.reject('Nenhuma conta encontrada');
    }

    const token = this.msalService.acquireTokenSilent({
      account: account,
      scopes: ['GroupMember.Read.All']
    });

    return token.then((response: any) => {
      const headers = {
        Authorization: `Bearer ${response.accessToken}`
      };
      console.log('getUserGroups-token', headers);
      return fetch('https://graph.microsoft.com/v1.0/me/memberOf', { headers }).then(res => res.json());
    });
  }

  getUserFromEmail(email: string): string {
    if (email && email.includes('@')) {
      return email.split('@')[0];
    }
    return email || '';
  }

  getProfiles(arrayGroups: string[]): string[] {
    const profilesMapfre: string[] = [
      "0031c726-df6d-4d51-aeef-a242bfc09f3a",
      "cb72caf8-958a-4edb-a038-2ffd54e97240",
      "4d40ead5-59c5-42f9-a61f-0686cfbc2dda",
      "f8bc4c06-c869-42f6-b8cd-d2dadeb7f0ae",
      "ea90266f-d8e3-4407-a298-39af028a9ea6",
      "3dc538b1-ed95-4c53-ac12-5211b0cac8ba",
      "93454880-ae48-4538-a2b1-5666a0b0c0c1",
      "74e83f35-8a91-412c-b9e6-b79e3a8d48d9",
      "3ac528c5-5d86-4abe-8789-f7a964fa3b63"
    ];
    const setB = new Set(profilesMapfre);
    return arrayGroups.filter(group => setB.has(group));
  }

  sendRequestToADV(body: any) {
    console.log('Enviando dados para API:', body);
    
    this.authService.signInAdv2(body).subscribe({
      next: (response) => {
        console.log('✅ Resposta da API ADV:', response);
        
        
        if (response.body && response.body.success && response.body.data) {
          const data = response.body.data;
          console.log('📊 Dados recebidos:', data);
          
          // Processa os dados retornados
          if (data.AccessToken) {
            console.log('🔑 AccessToken recebido:', data.AccessToken);
            console.log('⏰ ExpiresIn:', data.ExpiresIn);
            console.log('🔒 ExpiredPassword:', data.ExpiredPassword);
            console.log('👤 UserToken:', data.UserToken);
            
            // Armazena o token no localStorage
            window.localStorage.setItem('cp_tkn_x', data.AccessToken);
            console.log('✅ Token armazenado no localStorage');
            
            // Verifica se a senha expirou
            if (data.ExpiredPassword) {
              console.log('⚠️ Senha expirada, redirecionando para troca de senha');
              this.toastr.warning('Sua senha expirou. Por favor, altere sua senha.', 'Senha Expirada');
              // Aqui você pode redirecionar para uma página de troca de senha
              // this.router.navigate(['/change-password']);
            }
            
            // Continua com o fluxo de autenticação normal
            this.authService.authenticate(body, data.AccessToken).then((authResponse) => {
              console.log('✅ Autenticação finalizada:', authResponse);
              this.toastr.success('Login realizado com sucesso!', 'Sucesso!');
              this.router.navigate(['/private/home']);
            }).catch((error) => {
              console.error('❌ Erro na autenticação final:', error);
              this.toastr.error('Erro ao finalizar login', 'Erro!');
            });
            
          } else {
            console.error('❌ AccessToken não encontrado na resposta:', data);
            this.toastr.error('Token de acesso não recebido da API', 'Erro!');
          }
        } else {
          console.error('❌ Resposta inválida da API:', response);
          this.toastr.error('Resposta inválida da API', 'Erro!');
        }
      },
      error: (error) => {
        console.error('❌ Erro ao enviar dados para API ADV:', error);
        this.toastr.error('Erro ao processar dados do usuário', 'Erro!');
      }
    });
  }

  private async processAzureADLogin(result: any) {
    try {
      console.log('🔄 Processando login Azure AD...');
      console.log('Resultado recebido:', result);
      
      // Captura o token do Azure AD
      this.azureAdToken = result.accessToken || '';
      console.log('🔑 Token do Azure AD capturado:', this.azureAdToken);
      
      // Obtém informações do usuário do token do Azure AD
      const account = result.account;
      console.log('Conta do Azure AD:', account);
      
      const userInfo = {
        userName: account?.username || account?.userName || account?.preferred_username,
        email: account?.username || account?.userName || account?.preferred_username,
        adId: account?.localAccountId || account?.homeAccountId || account?.oid
      };

      console.log('👤 Informações do usuário Azure AD:', userInfo);

      // Chama setUserInfo() para processar informações do usuário do Azure AD
      console.log('👤 Processando informações do usuário...');
      this.setUserInfo();
    } catch (error) {
      console.error('Erro ao processar login Azure AD:', error);
      this.toastr.error(errorHandler(error), 'Falha na autenticação!');
    }
  }

  submit() {
    const identifier = this.form.get('identifier')?.value?.trim();
    if (!this.isEmail) {
      this.firstStep();
      return;
    }

    // se é e-mail e needsCpf está true, significa que o usuário não existe e o CPF deve ser informado
    if (this.isEmail && this.needsCpf) {
      const cpfValue = this.form.get('cpf')?.value;
      console.log("cpfValue", cpfValue);
      if (!cpfValue) {
        this.toastr.warning('Informe seu CPF para continuar.');
        return;
      }
      // armazena o CPF temporariamente (sessionStorage) antes de redirecionar
      sessionStorage.setItem('tempCpf', cpfValue);
      this.redirectToKeycloakLogin();
    }
    
  }

  async firstStep(keycloakResult = null) {
    console.log("keycloakResult", keycloakResult)
    try {
      this.spinner.show();
      let authenticateToken;
      if (keycloakResult) {
        authenticateToken = keycloakResult;
      }
      else{
        let identifier = this.form.get('identifier')?.value || '';
        const identifierOnlyNumbers = identifier.replace(/\D/g, '');
        authenticateToken = (await this.authService.authenticateToken({document: identifierOnlyNumbers, password: this.form.value.password})).body;
      }
      
      this.authService.token = authenticateToken.data.accessToken;
      if (authenticateToken.data.expiredPassword) {
        this.toastr.error(errorHandler("Sua senha expirou"), 'Falha na autenticação!');
        window.localStorage.setItem('expiredPasswordChangeToken', authenticateToken.data.expiredPasswordChangeToken);
        this.fToken.token.setValue(authenticateToken.data.expiredPasswordChangeToken)
        this.change = true;
        this.expire = true;
        this.login = false;
      } else {
        const result: any = await this.authService.authenticate(this.form.value, authenticateToken.data.accessToken);
        const values = result.body.data[0];
       
        this.listCompanyOne = values.companyPersons;
        window.localStorage.setItem('listInsurance', JSON.stringify(this.listCompanyOne));
        if (Object.keys(values.companyPersons).length === 0) {
          this.toastr.error(errorHandler("O usuário não está associado a nenhuma empresa"), 'Falha na autenticação!');
        } else {
          if (this.listCompanyOne.length == 1) {
            this.selectInsurance(this.listCompanyOne[0])
            this.select = false;
            return;
          }
          this.login = false;
          this.select = true;
          this.isStepCompany = true;
          this.isStepInsurance = false;
        }
      }

    } catch (error) {
      this.toastr.error(errorHandler(error.error.errors[0]), 'Falha na autenticação!');
    } finally {
      this.spinner.hide();
    }
    
  }

  async read() {

    try {
      this.spinner.show();
      const obj = {
        "personaId": this.personId,
        "termId": this.termId,
        "acceptedState": 2
      }
      const result: any = await this.authService.registerAccept(obj, this.accessToken);
      const values = result.body.data;
      if (values) {
        this.acceptLogin();
      }
    } catch (error) {
      this.toastr.error(errorHandler(error), 'Falha na autenticação!');
    } finally {
      this.spinner.hide();
    }
  }

  async selectCompany() {
    this.spinner.show();
    await this.delay(2000);
    this.select = false;
    this.insurance = true;
    this.spinner.hide();
  }

  async selectInsurance(insurance) {
    try {
      this.spinner.show();
      console.log("insurance", insurance)
      if (insurance.company) {
        this.companyId = insurance.companyId;
        this.personId = insurance.personId;
      }

      if (this.providerId) {

      }

      const obj = {
        personId: this.personId,
        companyId: insurance.isClient ? insurance.id : this.companyId,
        isClient: insurance.company ? insurance.company.isClient : insurance.isClient,
        isProvider: insurance.company ? insurance.company.isProvider : insurance.isProvider,
        isProviderValue: this.isProviderValue,
        isBroker: insurance.company ? insurance.company.isBroker : insurance.isBroker,
        isBrokerValue: this.isBrokerValue
      }

      if (!obj.isProvider && !obj.isClient && !obj.isBroker) {
        obj.isClient = true;
      }

      const objThree = {
        insuranceId: [insurance.id],
        providerId: [this.providerId],
        personId: this.personId
      }
      let result;

      if (this.providerId) {
        result = await this.authService.loginStepThree(objThree);
      } else {
        result = await this.authService.loginStepTwo(obj);
      }
      const values = result.body.data;

      if (insurance.companyName) {
        this.providerStr = JSON.stringify(insurance);
        window.localStorage.setItem('insurance', this.providerStr);
      } else {
        console.log("insurance", insurance)
        if (!insurance.company.companyId) {
          insurance.company.companyId = insurance.companyId
        }
        this.insuranceStr = JSON.stringify(insurance);
      }

      if (obj.isProvider == true) {
        this.providerId = insurance.companyId;
        this.isProviderValue = true;
        this.listCompanyTwo = values.item1;
        this.getInsurance();
      } else if (obj.isBroker) {
        this.providerId = insurance.companyId;
        this.isBrokerValue = true;
        this.listCompanyTwo = values.item1;
        if (values.item1.length == 1) {
          this.selectInsurance(values.item1[0]);
        } else {
          this.getInsurance();
        }

      } else {
        if (this.providerId) {
          this.accessToken = values.accessToken ? values.accessToken : this.accessTokenStorage;
        } else {
          this.accessToken = values.item2.accessToken ? values.item2.accessToken : this.accessTokenStorage;
        }

        this.checkTerm(obj, 'insurance')
      }
    } catch (error) {
      this.toastr.error(errorHandler(error), 'Falha na autenticação!');
    } finally {
      this.spinner.hide();
    }
  }

  private delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

  forgotView() {
    this.login = false;
    this.forgot = true;
  }

  loginView() {
    this.login = true;
    this.change = false;
    this.forgot = false;
  }

  async checkTerm(obj, type) {

    try {
      this.spinner.show();
      const result: any = await this.authService.getActiveTerm(obj, this.accessToken);
      const values = result.body;

      if (values.length > 0) {
        let accept = values[0].terms;

        const promises = accept.map(async (a) => {
          if (a.acceptedState === 2) {
            this.acceptLogin();
            return true
          } else {
            return false
          }
        });

        const promi = await Promise.all(promises);
        if (!promi[0]) {
          this.termText = values[0].termText;
          this.termId = values[0].id;
          this.getTerm(obj);
        }

      } else {
        this.acceptLogin();
      }

    } catch (error) {
      this.toastr.error(errorHandler(error), 'Falha na autenticação!');
    } finally {
      this.spinner.hide();
    }
  }

  acceptLogin() {
    this.authService.token = this.accessToken;
    window.localStorage.setItem('insurance', this.insuranceStr);
    if (this.providerStr) {
      window.localStorage.setItem('provider', this.providerStr);
    }
    this.router.navigate(['/cadastro/vistoria']);
  }

  async getTerm(obj) {
    try {
      this.spinner.show();
      const result: any = await this.authService.getCompanyTermList(this.companyId, this.accessToken);
      const values = result.body;


    } catch (error) {
      //this.toastr.error(errorHandler(error), 'Falha na autenticação!');
    } finally {
      this.spinner.hide();
    }
    this.select = false;
    this.term = true;
    this.login = false;
    this.insurance = false;
  }

  async getInsurance() {
    this.login = false;
    this.select = false;
    this.insurance = true;
    this.isStepCompany = false;
    this.isStepInsurance = true;
  }

  get insuranceName() {
    return window.localStorage.getItem('insurance');
  }

  get listInsurance() {
    return window.localStorage.getItem('listInsurance');
  }

  get accessTokenStorage() {
    return window.localStorage.getItem('cp_tkn_x');
  }

  get f() {
    return this.formRecovery.controls;
  }

  get fToken() {
    return this.formToken.controls;
  }

  openRecovery() {
    console.log("openRecovery", this.formRecovery.get('identifier')?.value)
    const raw = this.formRecovery.get('identifier')?.value || '';

    this.document = raw.replace(/\D/g, '');
    console.log("document", this.document)
    this.getEmails();
  }

  async getEmails() {
    this.spinner.show();
    this.emails = [];
    try {
      const result: any = (await this.userService.getEmails(this.document)).body;
      if (result.data) {
        let obj = {
          personId: result.data.personId,
          primaryEmail: result.data.primaryEmail,
          email: result.data.primaryEmail,
          userName: this.document
        }

        this.emails.push(obj);
        result.data.companyPersonEmails.map((c) => {
          let obj = {
            companyPersonId: c.companyPersonId,
            email: c.email,
            userName: this.document
          }

          this.emails.push(obj);
        })

        const dialogRef = this.dialog.open(RecoverPasswordComponent, {
          width: '60%',
          height: '90%',
          data: {
            document: this.f.identifier.value,
            emails: this.emails
          }
        })
      }
    } catch (error) {
      this.error = true;
      this.errorMsg = "CPF inexistente";
      this.toastr.error(errorHandler(error), 'Erro!');
    } finally {
      this.spinner.hide();
    }
  }

  validatePassword(value) {
    if (!this.hasLowerCase(value) || !this.hasUpperCase(value) || !this.hasNumber(value) || !this.hasSpecial(value)) {
      return false
    }
    return true;
  }

  hasLowerCase(str) {
    if (str) {
      return str.toUpperCase() != str;
    }
  }

  hasUpperCase(str) {
    return str.toLowerCase() != str;
  }

  hasNumber(str) {
    return /\d/.test(str);
  }

  hasSpecial(str) {
    var iChars = "~`!#$%^&@*+=-[]\\\';,/{}|\":<>?";

    for (var i = 0; i < str.length; i++) {
      if (iChars.indexOf(str.charAt(i)) != -1) {
        return true;
      }
    }
    return false;
  }

  confirmPassword() {
    if (this.fToken.newPassword.value === this.fToken.confirmPassword.value) {
      return true
    }
    return false;
  }

  async changePassword() {
    try {
      const rawIdentifier = this.formToken.value.identifier;
      const document = rawIdentifier.replace(/\D/g, '');
      const result: any = (await this.authService.changePassword({...this.formToken.value, document}));
      this.toastr.success(
        'Senha alterada com sucesso!',
        'Sucesso!'
      );
      this.loginView();
      await this.router.navigate(['/auth/login'], { replaceUrl: true });
    } catch (error) {
      this.toastr.error(errorHandler(error), 'Erro!');
    } finally {
      this.spinner.hide();
    }
  }

  // backToCompany(): void {
  //   this.providerId = undefined;
  //   this.firstStep()
  //   this.login = false;
  //   this.select = true;
  //   this.insurance = false;
  // }

  async backToCompany(): Promise<void> {    
    this.change = false;
    this.expire = false;


    localStorage.removeItem('provider');
    this.insurance = undefined;          // <— importante!
    this.listCompanyTwo = []; 
    
    if (!this.listCompanyOne || !this.listCompanyOne.length) {
      const cached = localStorage.getItem('listInsurance');
      if (cached) {
        try { this.listCompanyOne = JSON.parse(cached) || []; } catch { this.listCompanyOne = []; }
      }
    }    
    this.login = false;
    this.select = true;
    this.isStepCompany = true;
    this.isStepInsurance = false;
    
    const step = String(this.route.snapshot.params['step'] ?? '');
    if (step !== '1') {
      await this.router.navigate(['/auth/login', '1'], { replaceUrl: true });
    }
  }


}